






































import "./member-list.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import MemberSetup from "./member-setup.vue";
import InviteModal from "./invite.vue";

export default Vue.extend({
  name: "member-list",
  components: {
    UserAvatar,
    MemberSetup,
    InviteModal,
  },
  data() {
    return {
      showMemberSetup: false,
      showInvite: false,
      setupMember: null,
    };
  },
  computed: {
    ...mapState("team", ["loading", "currentTeam"]),
    ...mapGetters("team", ["currentTeamInviteRoles", "canInviteMemberInCurrentTeam"]),
    allMembers() {
      let team = (this as any).currentTeam;
      let members = team && team.members ? team.members : [];
      if (members === null) {
        members = [];
      }

      return members.map((member) => {
        return {
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          memberPhoneNumber: member.memberPhoneNumber,
          memberAvatarImageUrl: member.memberAvatarImageUrl,
          role: member.role,
          isOwner: member.isOwner,
          reinvite: member.accepted === false,
        };
      });
    },
    membersToShow() {
      return (this as any).allMembers.slice(0, 3);
    },
  },
  methods: {
    handleMemberClick(member) {
      this.showMemberSetup = true;
      this.setupMember = member;
    },
    handleInviteClick() {
      this.showInvite = true;
    },
  },
});
